<template>
    <div>

        <el-menu :default-active="$route.path" class="el-menu-demo" mode="horizontal" @select="handleSelect"
                background-color="#E53234"
                text-color="#fff"
                active-text-color="#EB5412">
            <el-menu-item index="/index">首页</el-menu-item>
            <el-menu-item index="/policyregulations2">找靠谱产品</el-menu-item>
            <el-menu-item index="/policyregulations2">找解决方案</el-menu-item>
            <el-menu-item index="/policyregulations2">找靠谱公司</el-menu-item>
            <el-menu-item index="/policyregulations2">找对的人</el-menu-item>
            <el-menu-item index="/policyregulations2">专家智库</el-menu-item>
            <el-menu-item index="/policyregulations2">论坛</el-menu-item>
            <el-menu-item index="/policyregulations2">悬赏任务</el-menu-item>
            <el-menu-item index="8">圈子</el-menu-item>
            <el-menu-item index="/policyregulations2">政策法规</el-menu-item>
            <el-menu-item index="10">圈子</el-menu-item>
            <!-- <el-submenu index="11">
                <template slot="title">求职招聘</template>
                <el-menu-item index="2-1">我要求职</el-menu-item>
                <el-menu-item index="2-2">我要招聘</el-menu-item>
                <el-menu-item index="2-3">职来职往</el-menu-item>
                <el-menu-item index="2-3">职场加油站</el-menu-item>
            </el-submenu> -->
            <el-menu-item index="12" disabled>SAAS</el-menu-item>
        </el-menu>

    </div>
</template>
<script>

    export default {
        name: 'head-menu',
        components: { },
        data() {
            return {
                activeValue: '1',
                activeIndex2: '1'
            }
        },
        methods:{
            handleSelect(key, keyPath) {
                console.log(key,keyPath);
            }
        },
        mounted: function () {

        },
    }
</script>

<style>
    .el-menu--horizontal.el-menu--dark .el-submenu .el-menu-item.is-active, .el-menu-item.is-active{
        color: #EB5412 !important;
        font-weight: 700;
    }
    .el-menu--horizontal>.el-menu-item:hover, .el-menu--horizontal>.el-submenu.is-active .el-submenu__title, .el-menu--horizontal>.el-submenu:hover .el-submenu__title{
        border-bottom: 5px solid #EB5412;
    }
    .el-menu--horizontal .el-menu-item{
        color: #dedede;
        font-size: 16px;
    }
    ::v-deep .el-menu{
        background-color: #232F3E;
    }
    .el-submenu__title{
        color: #dedede;
        font-size: 16px;
    }
    .el-menu--horizontal>.el-menu-item:hover{
        background-color: #EB5412;
        border-bottom: 5px solid #EB5412;
    }
    .el-submenu__title:hover{
        background-color: #EB5412;
    }


    .el-menu--horizontal>div>.el-menu-item{
        border-bottom: 5px solid #EB5412;
    }

</style>